<template>
  <div class="row">
    <div class="col-xl-4 mb-4 mb-xl-0">
      <div class="card writing-preview-card mb-4">
        <div class="card-body">
          <div class="section-heading mb-4">Bài học viên</div>
          <div class="preview-panel">
            <div class="preview-panel__body">
              <!-- <p class="mb-2"><span class="font-weight-bold">Kỹ năng:</span> {{ currentHomework && currentHomework.skill }}</p>
              <p class="mb-2"><span class="font-weight-bold">Năng lực:</span> {{ currentHomework && currentHomework.capacity }}</p> -->
              <p class="mb-3 preview-script">
                <span class="font-weight-bold">Câu hỏi:</span>
                <span v-html="currentHomework && currentHomework.group_question && currentHomework.group_question.description"></span>
              </p>
              <div v-if="currentHomework && currentHomework.group_question && currentHomework.group_question.script" class="preview-script mb-3" v-html="currentHomework.group_question.script"></div>
              <img
                v-if="currentHomework && currentHomework.group_question && currentHomework.group_question.image"
                :src="currentHomework.group_question.image"
                alt="question"
                class="img-fluid rounded"
              >
              <audio
                v-if="currentHomework && currentHomework.group_question && currentHomework.group_question.audio"
                class="w-100 mt-3"
                controls
                preload="auto"
              >
                <source :src="currentHomework.group_question.audio" type="audio/ogg">
                <source :src="currentHomework.group_question.audio" type="audio/mpeg">
              </audio>
            </div>
          </div>
        </div>
      </div>

      <div class="card writing-comment-card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="section-heading mb-0 text-capitalize">Danh sách nhận xét</div>
            <div class="comment-counter" :class="listCommentOfTeacher.length >= requiredMinimumComment ? 'text-primary' : 'text-danger'">
              {{ listCommentOfTeacher.length }}/{{ requiredMinimumComment }}
            </div>
          </div>

          <div v-if="listCommentError" class="invalid-feedback d-block mb-3">{{ listCommentError }}</div>

          <div v-if="listCommentOfTeacher.length" class="comment-list">
            <div
              v-for="(comment, indexComment) in listCommentOfTeacher"
              :key="indexComment"
              class="comment-card"
              @click="editComment(indexComment)"
            >
              <div class="comment-card__header">
                <span>{{ indexComment + 1 }}. {{ truncateComment(comment.text) }}</span>
                <button type="button" class="btn btn-link p-0 text-white" @click.stop="deleteComment(indexComment)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
              <div class="comment-card__body">
                {{ comment.feedback }}
              </div>
            </div>
          </div>

          <div v-else class="text-muted">Chưa có nhận xét.</div>
        </div>
      </div>
    </div>

    <div class="col-xl-8">
      <div class="card writing-answer-card mb-4">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="section-heading mb-0">Bài làm học viên</div>
            <div class="word-count">Số từ: {{ wordCount }}</div>
          </div>
          <div class="answer-box" @mouseup="getSelectionText" @touchend="handleTouchSelection">
            <span v-for="(item, index) in answerSegments" :key="'segment-' + index">
              <span v-if="item.type === 1" class="highlighted-text">{{ item.text }}</span>
              <span v-else>{{ item.text }}</span>
            </span>
          </div>
        </div>
      </div>

      <SpeakingAssessment
        type="writing"
        :evaluation-status="evaluationStatus"
        :not-meet-reason="notMeetReason"
        :not-meet-description="notMeetDescription"
        :force-validate="forceValidate"
        @update:speakingEvaluation="handleSpeakingEvaluationUpdate"
      />

      <div class="card writing-score-card">
        <div class="card-body">
          <div class="section-heading mb-4">Chấm bài</div>

          <div class="criteria-grid">
            <div v-for="criterion in gradingCriteria" :key="criterion.key" class="criteria-item">
              <div class="criteria-item__label">
                {{ criterion.label }} <span class="text-danger">*</span>
              </div>
              <div class="criteria-item__rate">
                <el-rate
                  class="admin-rate"
                  size="large"
                  :max="typeCourse"
                  :show-score="true"
                  :value="criterionValue(criterion.key)"
                  :disabled="isGradingDisabled"
                  allow-half
                  @change="handleCriterionChange(criterion.key, $event)"
                />
              </div>
              <div v-if="criterionError(criterion.key)" class="invalid-feedback d-block mt-2">{{ criterionError(criterion.key) }}</div>
            </div>
          </div>

          <div class="total-score-box">
            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
              <div class="mb-3 mb-md-0">
                <div class="total-score-box__label">Điểm toàn bài</div>
                <div class="total-score-box__hint">Điểm trung bình của 4 tiêu chí writing</div>
              </div>

              <el-rate
                class="summary-rate"
                size="large"
                :max="10"
                :show-score="true"
                :value="totalScore"
                :disabled="true"
                allow-half
              />
            </div>
          </div>

          <div class="form-group mt-4 mb-0">
            <label class="field-label mb-2">Nhận xét tổng quan</label>

            <div v-if="hasAudioComment" class="audio-box">
              <div class="d-flex align-items-center justify-content-between flex-wrap">
                <div class="audio-box__content">
                  <div class="audio-box__label">
                    <img :src="successIcon" alt="success" class="audio-status-icon">
                    <span>Bản ghi âm nhận xét</span>
                  </div>
                  <audio controls class="audio-player">
                    <source :src="currentHomework.comment" type="audio/wav">
                    Trình duyệt không hỗ trợ phát audio.
                  </audio>
                </div>

                <div v-if="!isGradingDisabled" class="audio-box__actions">
                  <button type="button" class="btn btn-outline-primary btn-sm mr-2" @click="startVoiceRecording">
                    <img :src="voiceIcon" alt="voice" class="voice-icon mr-1">
                    Ghi âm lại
                  </button>
                  <button type="button" class="btn btn-outline-danger btn-sm" @click="deleteRecording">
                    Xóa
                  </button>
                </div>
              </div>
            </div>

            <div v-else class="comment-input-wrap">
              <el-input
                :value="commentValue"
                class="admin-textarea"
                :autosize="{ minRows: 3, maxRows: 5 }"
                type="textarea"
                :placeholder="isLowCourse ? 'Nhập nhận xét tổng quan (tối thiểu 30 ký tự nếu điểm < 7)' : 'Nhập nhận xét tổng quan'"
                :disabled="isGradingDisabled"
                @input="handleCommentInput"
                @focus="commentTouched = true"
                @blur="commentTouched = true"
              />
              <button
                v-if="!isGradingDisabled"
                type="button"
                class="btn btn-light comment-voice-btn"
                :class="{ recording: isRecording }"
                @click="startVoiceRecording"
              >
                <img :src="voiceIcon" alt="voice recording" class="voice-icon">
                <span>{{ isRecording ? 'Đang ghi âm' : 'Ghi âm' }}</span>
              </button>
            </div>

            <div v-if="commentError" class="invalid-feedback d-block mt-2">{{ commentError }}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" top="20vh" width="640px" :before-close="resetModal">
      <div class="dialog-title mb-4">{{ dialogTitle }}</div>
      <p class="mb-4"><strong>Nhận xét:</strong> {{ textComment }}</p>
      <el-input
        v-model="feedBack"
        class="w-100"
        :autosize="{ minRows: 5, maxRows: 10 }"
        type="textarea"
        placeholder="Nhận xét của bạn"
      />
      <div class="text-right mt-4">
        <el-button type="info" @click="resetModal">Đóng</el-button>
        <el-button type="primary" @click="addComment">Xác nhận</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import voiceIcon from '@/assets/img/voice.png'
import successIcon from '@/assets/img/success-icon.svg'
import SpeakingAssessment from './SpeakingAssessment.vue'
import { COURSE_BASIC_PRE_IE3_5_IE_4_5, GRADING_CRITERIA } from '../constant'


export default {
  name: 'MakeWriting',
  components: {
    SpeakingAssessment: SpeakingAssessment
  },
  props: {
    currentHomework: {
      type: Object,
      default: function () {
        return {}
      }
    },
    typeCourse: {
      type: Number,
      default: 0
    },
    forceValidate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gradingCriteria: GRADING_CRITERIA,
      voiceIcon: voiceIcon,
      successIcon: successIcon,
      dialogVisible: false,
      feedBack: '',
      textComment: '',
      indexTextComment: null,
      dialogTitle: 'Thêm nhận xét',
      editedCommentIndex: -1,
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      recordingStartTime: null,
      maxFileSize: 5 * 1024 * 1024,
      minDuration: 30,
      criteriaTouched: {
        achievement: false,
        lexical: false,
        coherence: false,
        grammatical: false
      },
      commentTouched: false
    }
  },
  computed: {
    speakingEvaluation() {
      if (!this.currentHomework.speakingEvaluation) {
        this.$set(this.currentHomework, 'speakingEvaluation', this.defaultSpeakingEvaluation())
      }
      return this.currentHomework.speakingEvaluation
    },
    evaluationStatus() {
      return this.speakingEvaluation.evaluationStatus || 'pass'
    },
    notMeetReason() {
      return this.speakingEvaluation.notMeetReason || ''
    },
    notMeetDescription() {
      return this.speakingEvaluation.notMeetDescription || ''
    },
    isGradingDisabled() {
      return this.evaluationStatus === 'fail'
    },
    isLowCourse() {
      return Number(this.typeCourse) === COURSE_BASIC_PRE_IE3_5_IE_4_5
    },
    listCommentOfTeacher() {
      return this.currentHomework && this.currentHomework.listComment ? this.currentHomework.listComment : []
    },
    requiredMinimumComment() {
      const numberOfCharacters = this.currentHomework && this.currentHomework.student_answer ? this.currentHomework.student_answer.length : 0
      return numberOfCharacters < 100 ? 1 : this.isLowCourse ? 1 : 3
    },
    answerSegments() {
      const answers = (this.currentHomework && this.currentHomework.student_answer ? this.currentHomework.student_answer : '').trim()
      if (!this.listCommentOfTeacher.length) {
        return [{ text: answers, type: 0 }]
      }

      const sortedComments = this.listCommentOfTeacher
        .slice()
        .filter((comment) => typeof comment.index === 'number' && comment.text)
        .sort((a, b) => a.index - b.index)

      const segments = []
      let cursor = 0

      sortedComments.forEach((comment) => {
        const commentStart = Math.max(comment.index, cursor)
        const commentEnd = Math.min(comment.index + comment.text.length, answers.length)

        if (commentStart > cursor) {
          segments.push({ text: answers.slice(cursor, commentStart), type: 0 })
        }

        if (commentEnd > commentStart) {
          segments.push({ text: answers.slice(commentStart, commentEnd), type: 1 })
          cursor = commentEnd
        }
      })

      if (cursor < answers.length) {
        segments.push({ text: answers.slice(cursor), type: 0 })
      }

      return segments.length ? segments : [{ text: answers, type: 0 }]
    },
    wordCount() {
      const text = (this.currentHomework && this.currentHomework.student_answer ? this.currentHomework.student_answer : '').trim()
      if (!text) return 0
      return text.split(/\s+/).filter((word) => word.length > 0).length
    },
    totalScore() {
      if (this.isGradingDisabled) {
        this.$set(this.currentHomework, 'score', 0)
        return 0
      }

      const criteria = this.gradingCriteria.map((criterion) => Number(this.currentHomework[criterion.key] || 0))
      const allCriteriaFilled = criteria.every((score) => score > 0)
      if (!allCriteriaFilled) {
        this.$set(this.currentHomework, 'score', 0)
        return 0
      }

      const average = criteria.reduce((sum, score) => sum + score, 0) / this.gradingCriteria.length
      const rounded = this.roundTotalScore(average)
      this.$set(this.currentHomework, 'score', rounded)
      return rounded
    },
    commentValue() {
      return this.currentHomework && this.currentHomework.comment ? this.currentHomework.comment : ''
    },
    hasAudioComment() {
      return typeof this.commentValue === 'string' && this.commentValue.indexOf('blob:') === 0
    },
    listCommentError() {
      if (this.isGradingDisabled || !this.forceValidate) return ''
      return this.listCommentOfTeacher.length >= this.requiredMinimumComment ? '' : 'Vui lòng nhập đủ nhận xét'
    },
    commentError() {
      if (!this.commentTouched || this.isGradingDisabled || !this.isLowCourse) return ''

      const score = Number(this.currentHomework && this.currentHomework.score ? this.currentHomework.score : 0)
      if (score > 0 && score < 7) {
        if (!this.commentValue || (typeof this.commentValue === 'string' && this.commentValue.indexOf('blob:') !== 0 && this.commentValue.trim().length < 30)) {
          return 'Nhận xét phải có ít nhất 30 ký tự khi điểm < 7'
        }
      }

      return ''
    }
  },
  watch: {
    forceValidate(newValue) {
      if (newValue) {
        this.commentTouched = true
        Object.keys(this.criteriaTouched).forEach((key) => {
          this.$set(this.criteriaTouched, key, true)
        })
      }
    },
    listCommentOfTeacher: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.currentHomework) {
          this.$set(this.currentHomework, 'achieveMinComment', this.isGradingDisabled ? true : value.length >= this.requiredMinimumComment)
          this.$set(this.currentHomework, 'listComment', value)
          this.$set(this.currentHomework, 'commentToAnswer', value)
        }
      }
    },
    evaluationStatus() {
      if (this.isGradingDisabled) {
        this.gradingCriteria.forEach((criterion) => {
          this.$set(this.currentHomework, criterion.key, 0)
        })
        this.$set(this.currentHomework, 'score', 0)
      }
    }
  },
  created() {
    this.ensureWritingData()
  },
  beforeDestroy() {
    if (this.isRecording && this.mediaRecorder) {
      this.mediaRecorder.stop()
    }
  },
  methods: {
    defaultSpeakingEvaluation() {
      return {
        evaluationStatus: 'pass',
        notMeetReason: '',
        notMeetDescription: ''
      }
    },
    ensureWritingData() {
      if (!this.currentHomework) return

      if (!this.currentHomework.speakingEvaluation) {
        this.$set(this.currentHomework, 'speakingEvaluation', this.defaultSpeakingEvaluation())
      }

      this.gradingCriteria.forEach((criterion) => {
        if (this.currentHomework[criterion.key] === undefined || this.currentHomework[criterion.key] === null) {
          this.$set(this.currentHomework, criterion.key, 0)
        }
      })

      if (this.currentHomework.score === undefined || this.currentHomework.score === null) {
        this.$set(this.currentHomework, 'score', 0)
      }
      if (!this.currentHomework.comment) {
        this.$set(this.currentHomework, 'comment', '')
      }
      if (!this.currentHomework.listComment) {
        this.$set(this.currentHomework, 'listComment', this.currentHomework.commentToAnswer || [])
      }
      if (!this.currentHomework.commentToAnswer) {
        this.$set(this.currentHomework, 'commentToAnswer', this.currentHomework.listComment)
      }
      if (this.currentHomework.achieveMinComment === undefined) {
        this.$set(this.currentHomework, 'achieveMinComment', this.listCommentOfTeacher.length >= this.requiredMinimumComment)
      }
    },
    roundTotalScore(score) {
      const roundedTo2Decimals = Math.round(score * 100) / 100
      const decimal = roundedTo2Decimals % 1
      const base = Math.floor(roundedTo2Decimals)

      if (decimal < 0.25) return base
      if (decimal < 0.75) return base + 0.5
      return base + 1
    },
    criterionValue(key) {
      return this.currentHomework && this.currentHomework[key] ? this.currentHomework[key] : 0
    },
    criterionError(key) {
      if (this.isGradingDisabled || !this.criteriaTouched[key]) return ''
      return Number(this.currentHomework && this.currentHomework[key] ? this.currentHomework[key] : 0) > 0
        ? ''
        : 'Vui lòng chấm điểm ' + this.gradingCriteria.find((criterion) => criterion.key === key).label
    },
    handleCriterionChange(key, value) {
      this.$set(this.criteriaTouched, key, true)
      this.$set(this.currentHomework, key, value)
      this.$set(this.currentHomework, 'score', this.totalScore)
      this.commentTouched = true
    },
    handleSpeakingEvaluationUpdate(payload) {
      if (!this.currentHomework.speakingEvaluation) {
        this.$set(this.currentHomework, 'speakingEvaluation', this.defaultSpeakingEvaluation())
      }

      this.$set(this.currentHomework.speakingEvaluation, payload.type, payload.value)
      if (payload.type === 'evaluationStatus' && payload.value === 'pass') {
        this.$set(this.currentHomework.speakingEvaluation, 'notMeetReason', '')
        this.$set(this.currentHomework.speakingEvaluation, 'notMeetDescription', '')
      }
    },
    truncateComment(text) {
      if (!text) return ''
      return text.length > 40 ? text.substring(0, 40) + '...' : text
    },
    handleTouchSelection() {
      setTimeout(() => {
        this.getSelectionText()
      }, 100)
    },
    getSelectionText() {
      let selection = ''
      if (window.getSelection) {
        selection = window.getSelection()
      } else if (document.selection && document.selection.type !== 'Control') {
        selection = document.selection.createRange().text
      }

      const selectedText = selection ? selection.toString().trim() : ''
      const answers = this.currentHomework && this.currentHomework.student_answer ? this.currentHomework.student_answer : ''
      if (!selectedText || answers.indexOf(selectedText) === -1) {
        return
      }

      const anchorOffset = typeof selection.anchorOffset === 'number' ? selection.anchorOffset : answers.indexOf(selectedText)
      const focusOffset = typeof selection.focusOffset === 'number' ? selection.focusOffset : anchorOffset + selectedText.length
      const startIndex = anchorOffset < focusOffset ? anchorOffset : focusOffset
      const duplicated = this.listCommentOfTeacher.find((item) => item.index === startIndex && item.text.length === selectedText.length)
      if (duplicated) {
        return
      }

      this.textComment = selectedText
      this.indexTextComment = startIndex
      this.dialogTitle = 'Thêm nhận xét'
      this.feedBack = ''
      this.editedCommentIndex = -1
      this.dialogVisible = true
    },
    addComment() {
      if (!this.feedBack) {
        this.$message.error('Vui lòng nhập nhận xét')
        return
      }

      const comment = {
        text: this.textComment,
        feedback: this.feedBack,
        index: this.indexTextComment
      }

      const nextComments = this.listCommentOfTeacher.slice()
      if (this.dialogTitle === 'Sửa nhận xét' && this.editedCommentIndex > -1) {
        nextComments.splice(this.editedCommentIndex, 1, comment)
      } else {
        nextComments.push(comment)
      }

      nextComments.sort((a, b) => a.index - b.index)
      this.$set(this.currentHomework, 'listComment', nextComments)
      this.$set(this.currentHomework, 'commentToAnswer', nextComments)
      this.resetModal()
    },
    resetModal() {
      this.dialogVisible = false
      this.feedBack = ''
      this.textComment = ''
      this.indexTextComment = null
      this.dialogTitle = 'Thêm nhận xét'
      this.editedCommentIndex = -1
    },
    deleteComment(index) {
      const nextComments = this.listCommentOfTeacher.slice()
      nextComments.splice(index, 1)
      this.$set(this.currentHomework, 'listComment', nextComments)
      this.$set(this.currentHomework, 'commentToAnswer', nextComments)
    },
    editComment(index) {
      const editedComment = this.listCommentOfTeacher[index]
      if (!editedComment) return

      this.editedCommentIndex = index
      this.dialogTitle = 'Sửa nhận xét'
      this.textComment = editedComment.text
      this.feedBack = editedComment.feedback
      this.indexTextComment = editedComment.index
      this.dialogVisible = true
    },
    handleCommentInput(value) {
      this.commentTouched = true
      this.$set(this.currentHomework, 'comment', value)
    },
    resetRecording(stream) {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop())
      }
      this.isRecording = false
      this.recordingStartTime = null
      this.audioChunks = []
    },
    validateRecording(duration, audioBlob) {
      if (duration < this.minDuration) {
        this.$message.error('Thời lượng ghi âm tối thiểu ' + this.minDuration + 's. Bạn đã ghi ' + Math.round(duration) + 's.')
        return false
      }
      if (audioBlob.size > this.maxFileSize) {
        const sizeMb = (audioBlob.size / (1024 * 1024)).toFixed(2)
        this.$message.error('Dung lượng file vượt quá 5MB (' + sizeMb + 'MB). Vui lòng ghi âm ngắn hơn.')
        return false
      }
      return true
    },
    startVoiceRecording() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
        this.$message.error('Trình duyệt không hỗ trợ ghi âm. Vui lòng dùng Chrome/Firefox/Edge.')
        return
      }

      if (this.isRecording) {
        this.stopVoiceRecording()
        return
      }

      this.$message.info('Đang yêu cầu quyền truy cập microphone...')

      navigator.mediaDevices.getUserMedia({ video: false, audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream)
          this.audioChunks = []
          this.recordingStartTime = Date.now()

          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.audioChunks.push(event.data)
            }
          }

          this.mediaRecorder.onstop = () => {
            const duration = (Date.now() - this.recordingStartTime) / 1000
            const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })

            if (!this.validateRecording(duration, audioBlob)) {
              this.resetRecording(stream)
              return
            }

            const url = URL.createObjectURL(audioBlob)
            this.handleCommentInput(url)
            this.resetRecording(stream)

            const sizeMb = (audioBlob.size / (1024 * 1024)).toFixed(2)
            this.$message.success('Ghi âm thành công! Thời lượng: ' + Math.round(duration) + 's, Dung lượng: ' + sizeMb + 'MB')
          }

          this.mediaRecorder.onerror = () => {
            this.$message.error('Lỗi ghi âm. Vui lòng thử lại.')
            this.resetRecording(stream)
          }

          this.isRecording = true
          this.mediaRecorder.start()
          this.$message.info('Đang ghi âm...')
        })
        .catch(() => {
          this.$message.error('Không thể truy cập microphone.')
        })
    },
    stopVoiceRecording() {
      if (this.mediaRecorder) {
        this.mediaRecorder.stop()
      }
    },
    deleteRecording() {
      if (this.currentHomework && this.currentHomework.comment && this.currentHomework.comment.indexOf('blob:') === 0) {
        URL.revokeObjectURL(this.currentHomework.comment)
      }
      this.handleCommentInput('')
      this.$message.success('Đã xóa bản ghi âm.')
    }
  }
}
</script>

<style lang="scss" scoped>
.writing-preview-card,
.writing-comment-card,
.writing-answer-card,
.writing-score-card {
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5rem rgba(140, 152, 164, 0.08);
}

.section-heading {
  font-size: 1.05rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #3f4254;
  letter-spacing: 0.04em;
}

.preview-panel,
.score-box,
.total-score-box {
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #f8f9fc;
}

.preview-panel__body,
.answer-box {
  font-size: 0.975rem;
  color: #3f4254;
  line-height: 1.8;
}

.preview-script {
  white-space: pre-line;
}

.comment-counter,
.word-count {
  font-size: 1rem;
  font-weight: 700;
}

.comment-list {
  max-height: 420px;
  overflow-y: auto;
}

.comment-card {
  margin-bottom: 0.75rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.comment-card:hover {
  box-shadow: 0 0.5rem 1.25rem rgba(140, 152, 164, 0.15);
  transform: translateY(-1px);
}

.comment-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: linear-gradient(90deg, #5867dd 0%, #3699ff 100%);
  color: #fff;
  font-weight: 600;
}

.comment-card__body {
  padding: 1rem;
  background: #f8f9fc;
  color: #3f4254;
}

.answer-box {
  min-height: 360px;
  max-height: 420px;
  overflow-y: auto;
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #f8f9fc;
  white-space: pre-wrap;
  cursor: text;
}

.highlighted-text {
  background: #ffe27a;
  color: #1f1f1f;
}

.criteria-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 1.5rem 1rem;
}

.criteria-item__label,
.field-label,
.total-score-box__label {
  font-size: 1rem;
  font-weight: 700;
  color: #3f4254;
  text-transform: uppercase;
}

.criteria-item__rate,
.score-box__rate {
  margin-top: 0.5rem;
}

.total-score-box {
  margin-top: 1.5rem;
}

.total-score-box__hint {
  margin-top: 0.25rem;
  font-size: 0.975rem;
  color: #7e8299;
}

.comment-input-wrap {
  position: relative;
}

.comment-voice-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.75rem;
  border-color: #e4e6ef;
  color: #3f4254;
  font-size: 0.95rem;
}

.comment-voice-btn.recording {
  background: #fff4f4;
  border-color: #f64e60;
  color: #f64e60;
}

.voice-icon {
  width: 1rem;
  height: 1rem;
  object-fit: contain;
}

.audio-box {
  padding: 1rem 1.25rem;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
}

.audio-box__content {
  flex: 1 1 auto;
  min-width: 260px;
}

.audio-box__label {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 0.975rem;
  font-weight: 500;
  color: #3f4254;
}

.audio-status-icon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
}

.audio-box__actions {
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
}

.audio-player {
  width: 100%;
  max-width: 420px;
}

.dialog-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #181c32;
}

.admin-rate::v-deep .el-rate {
  display: flex;
  align-items: center;
}

.admin-rate::v-deep .el-rate__text,
.summary-rate::v-deep .el-rate__text {
  margin-left: 0.5rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: #3699ff;
}

.admin-textarea::v-deep .el-textarea__inner {
  border-color: #e4e6ef;
  border-radius: 0.475rem;
  min-height: 110px;
  padding: 0.75rem 0.875rem;
  font-size: 0.975rem;
  line-height: 1.7;
}

@media (max-width: 991.98px) {
  .criteria-grid {
    grid-template-columns: 1fr;
  }
}
</style>
